import { gql } from '@apollo/client';
import _ from 'lodash';

export const GET_OVERRIDEN_WORKSPACES = gql`
  query OverridenWorkspaces {
    overridenWorkspaces {
      id
      company {
        id
        name
      }
    }
  }
`;

export const GET_CONTROLS_BY_COMPANY = gql`
  query PlaybookuxControls($companyId: ID) {
    playbookuxControls(companyId: $companyId) {
      iosSend
      iosApprove
      androidSend
      androidApprove
      macosSend
      macosApprove
      windowsSend
      windowsApprove
      unmodConsumerSend
      unmodConsumerApprove
      unmodProfessionalSend
      unmodProfessionalApprove
      modApprove
      modDidnotshow
      modSend
      cardSortSend
      cardSortApprove
      treeTestSend
      treeTestApprove
      surveySend
      surveyApprove
    }
  }
`;

export const GET_ALL_SEND_CONTROLS = gql`
  query PlaybookuxSendControls {
    playbookuxSendControls {
      iosSend
      androidSend
      macosSend
      windowsSend
      cardSortSend
      treeTestSend
      surveySend
      company {
        id
      }
    }
  }
`;

export const UPDATE_COMPANY_CONTROLS = gql`
  mutation UpdatePlaybookuxControls($attributes: ControlsAttributes!, $companyId: ID) {
    updatePlaybookuxControls(attributes: $attributes, companyId: $companyId) {
      company {
        id
        name
        playbookuxControl {
          id
          isOverriden
        }
      }
    }
  }
`;

export const RESET_WORKSPACES = gql`
  mutation ResetWorkspaces {
    resetWorkspaces {
      playbookuxControl {
        androidApprove
        androidSend
        cardSortApprove
        cardSortSend
        iosApprove
        iosSend
        macosApprove
        macosSend
        modApprove
        modDidnotshow
        modSend
        surveyApprove
        surveySend
        treeTestApprove
        treeTestSend
        unmodConsumerApprove
        unmodConsumerSend
        unmodProfessionalApprove
        unmodProfessionalSend
        windowsApprove
        windowsSend
      }
    }
  }
`;

export const handleUpdateCompanyControlsMutationUpdate = async (cache, { data }) => {
  if (!data) return;
  const { updatePlaybookuxControls = {} } = data;
  const { company = {} } = updatePlaybookuxControls;
  const { playbookuxControl } = company || {};
  const { overridenWorkspaces } = cache.readQuery({ query: GET_OVERRIDEN_WORKSPACES });

  let updatedQuery = overridenWorkspaces;
  if (playbookuxControl) {
    if (playbookuxControl.isOverriden) {
      const alreadyOverriden = !_.isEmpty(overridenWorkspaces.filter(({ id }) => id === playbookuxControl.id));
      if (!alreadyOverriden) {
        updatedQuery = [
          ...overridenWorkspaces,
          {
            id: playbookuxControl.id,
            company: {
              id: company.id,
              name: company.name,
            },
          },
        ];
      }
    } else {
      updatedQuery = updatedQuery.filter(({ company: { id } }) => id !== company.id);
    }
  }

  cache.writeQuery({
    query: GET_OVERRIDEN_WORKSPACES,
    data: {
      overridenWorkspaces: updatedQuery,
    },
  });
};

export const handleResetWorkspacesUpdate = async (cache) => {
  cache.writeQuery({
    query: GET_OVERRIDEN_WORKSPACES,
    data: {
      overridenWorkspaces: [],
    },
  });
};
